import PollItem from './PollItem';

export default PollItem;
